<script setup>
import {useI18n} from "vue-i18n";

const {t} = useI18n()
</script>

<template>
  <!-- footer -->
  <div class="footer">
    <div class="footer_inner">
      <div>
        <h3 class="footer_logo">
          <b>{{t('footer.title')}}</b>
          <p class="second_title" style="font-size: 1.6rem;">{{t('footer.secondTitle')}}</p>
          </h3>
        <address>
          <span class="addr">{{t('footer.addr')}}</span>
          <span class="tel"> 02-730-3760</span>
        </address>
      </div>

      <ul class="footer_menu">
        <router-link to="/termsInfo"><li><a href="#">{{t('footer.termsInfo')}}</a></li></router-link>
        <router-link to="/privacyInfo"><li><a href="#">{{t('footer.privacyInfo')}}</a></li></router-link>
      </ul>
    </div>
  </div>
  <!-- // footer -->
</template>

<style scoped>
@media screen and (max-width: 767px) {
  .footer .footer_logo .second_title {
    font-size: 1rem !important;
    line-height: 1.4rem;
    width: 60%;
  }

  .footer address .addr {
    width: 60%;
  }
}

@media screen and (min-width: 768px) {

  .footer .footer_menu {
    left : 28rem;
  }
}

</style>